import {
  Flex,
  Heading,
  IconButton,
  IconXLine,
  Pill,
  Text,
  TextArea,
} from "@instructure/ui";
import { t } from "i18next";
import { useContext } from "react";
import { Card } from "../../Card";
import CustomRTE from "../../CustomTextArea/CustomRTE";
import { CourseReviewContext } from "../CourseReview";

const CourseReviewActions = () => {
  const { draftData, setDraftData } = useContext(CourseReviewContext);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
        height: "100%",
      }}
    >
      <Heading level="h3" as="h2" border="bottom">
        {t("courseReview.actionsInReview")}
      </Heading>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          padding: "0.75rem",
          margin: "-0.75rem",
          overflowY: "auto",
        }}
      >
        <CustomRTE
          id="action-summary"
          label={
            <Text as="p" weight="bold">
              {t("courseReview.actionsSummary")}
            </Text>
          }
          defaultValue={draftData.actionsSummary}
          onChange={(value) =>
            setDraftData((prev) => ({ ...prev, actionsSummary: value }))
          }
        />
        {draftData.selectedActions?.length > 0 ? (
          draftData.selectedActions.map((action) => (
            <Card
              key={action.id}
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                height: "auto",
              }}
            >
              <Flex alignItems="start" wrap="wrap" gap="small">
                <Flex.Item shouldShrink shouldGrow>
                  <Pill color="info">{action.action_type.name}</Pill>
                </Flex.Item>
                <Flex.Item shouldShrink>
                  <IconButton
                    screenReaderLabel={t("courseReview.removeAction")}
                    onClick={() => {
                      setDraftData((prev) => ({
                        ...prev,
                        selectedActions: prev.selectedActions.filter(
                          (a) => a.id !== action.id
                        ),
                      }));
                    }}
                    renderIcon={IconXLine}
                    size="small"
                    color="danger"
                  />
                </Flex.Item>
                <Flex.Item size="100%">
                  <TextArea
                    label={t("courseReview.revisedAction")}
                    size="small"
                    defaultValue={action.text}
                    onBlur={(e) => {
                      const newText = e.target.value;
                      setDraftData((prev) => ({
                        ...prev,
                        selectedActions: prev.selectedActions.map((a) =>
                          a.id === action.id ? { ...a, text: newText } : a
                        ),
                      }));
                    }}
                  />
                </Flex.Item>
              </Flex>
            </Card>
          ))
        ) : (
          <Text fontStyle="italic">
            {t("courseReview.selectActionsFromLeft")}
          </Text>
        )}
      </div>
    </div>
  );
};

export default CourseReviewActions;
